import request from '@/request'

export async function updateUserAvatar (userId, file) {
  const formData = new FormData()
  formData.append('_method', 'put')
  formData.append('avatar_file', file)

  const response = await request({
    url: `/users/${userId}`,
    method: 'post',
    data: formData
  })

  return response.data.data
}

export async function updateUser (userId, data) {
  const response = await request({
    url: `/users/${userId}`,
    method: 'post',
    data: {
      '_method': 'PUT',
      ...data
    }
  })

  return response.data
}

export async function updateUserPaymentExtraDetails (data) {
  const response = await request({
    url: `/users/me/payment-extra-details`,
    method: 'post',
    data
  })

  return response.data.data
}

export async function getAuthors (params) {
  const response = await request({
    url: '/authors',
    method: 'get',
    params,
  })

  return response.data
}

export async function checkByEmail (email) {
  const response = await request({
    url: '/users/check',
    method: 'post',
    data: { email }
  })

  return response.data.data.user
}

export async function getUserAddress (userId) {
  const response = await request({
    url: `/users/${userId}/address`,
    method: 'get'
  })

  return response.data.data
}

export async function updateUserAddress (data) {
  await request({
    url: `/users/me/address`,
    method: 'post',
    data
  })
}

export async function getAuthorById (userId) {
  const res = await request({
    url: `/authors/${userId}`,
    method: 'get'
  })

  return res.data
}

export async function getAuthorCourses (userId, page = 1) {
  const res = await request({
    url: `/authors/${userId}/courses?page=${page}`,
    method: 'get'
  })

  return res.data
}

export async function getUserCourseWatchHistory (userId, page = 1) {
  return await request({
    url: `/users/${userId}/course-history?page=${page}`,
    method: 'get'
  })
}

export async function getUserProfile (slug) {
  return await request({
    url: `/users/${slug}/profile`,
    method: 'get'
  })
}

export async function getUsersRank (params = {}) {
  return await request({
    url: `/users/rank`,
    method: 'get',
    params
  })
}

export async function getUserSettings() {
  const res = await request({
    url: `/users/me/settings`,
    method: 'get'
  })

  return res.data
}
